import {useUpmPlant} from '@hconnect/upm'

import {useKilns} from '@refra/modules/common/providers'
import {useKilnConfig} from '@refra/modules/refra-planning/hooks/queries'
import {useUrlParam} from '@refra/modules/routing/hooks'

export const useValidateHeatZones = () => {
  const plantId = useUrlParam('plantCode')
  const upmPlant = useUpmPlant({plantId})
  const {selectedKiln} = useKilns()

  const {
    data: kilnConfig,
    isLoading: isKilnConfigLoading,
    error: kilnConfigError
  } = useKilnConfig({
    plantUpmId: upmPlant.upmId,
    kilnUpmId: selectedKiln.upmId
  })

  const areHeatZonesValid =
    !!kilnConfig &&
    kilnConfigError?.response?.status !== 404 &&
    !!kilnConfig.payload.layout.heatZones &&
    kilnConfig.payload.layout.heatZones.length > 0

  return {areHeatZonesValid, areHeatZonesLoading: isKilnConfigLoading}
}
